module.exports = __webpack_public_path__ + "img/Hover_Money_Transfer.b56d8b97.png";